import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import Moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const IncomebyCustomerSummary = (props) => {
  const token = localStorage.getItem("Token");
  const gridRef = useRef();
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalexpense, setTotalexpense] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState(Moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(Moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [row, setRow] = useState(false);
  const [column, setColumn] = useState(false);
  const [children, setChildren] = useState([]);
  const [reset, setReset] = useState(false);

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const options = [
    { label: "Select Period", value: 0 },
    { label: "% by row", value: 1 },
    { label: "% by column", value: 2 },
  ];

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Customer Name",
      field: "Customername",
      minWidth: 130,
      enableRowGroup: true,
    },
    {
      headerName: "Income",

      field: "Income",
      suppressMenu: true,
      // rowGroup: true,
      filter: "agNumberColumnFilter",

      aggFunc: "sum",
      // enableRowGroup: true,
      enableValue: true,
      // groupIncludeFooter: true,
      valueGetter: ({ data }) => `$ ${Number(data.Income).toFixed(2)}`,

      minWidth: 130,
    },

    {
      headerName: "Expense",

      field: "Expense",
      suppressMenu: true,
      filter: "agNumberColumnFilter",
      aggFunc: "sum",

      enableValue: true,
      //  groupIncludeFooter: true,
      valueGetter: ({ data }) => `$ ${Number(data.Expense).toFixed(2)}`,

      minWidth: 130,
    },
    {
      headerName: "Net Income",

      field: "Net Income",
      suppressMenu: true,
      filter: "agNumberColumnFilter",
      aggFunc: "sum",
      // enableRowGroup: true,
      enableValue: true,
      // groupIncludeFooter: true,
      valueGetter: ({ data }) => `$ ${Number(data.Income).toFixed(2)}`,

      minWidth: 130,
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
    };
  }, []);

  //Function to generate barcode
  const handleChange = (e) => {
    const val = e.value;
    console.log(val, "value");
    if (val == 0) {
      setReset(true);
    }
    if (val == 2) {
      setColumn(true);
      setRow(false);
    }

    if (val == 1) {
      setColumn(false);
      setRow(true);
    }
  };

  console.log(column, "col");
  const income = responseData.reduce(
    (total, data) => total + Number(data.Income),
    0
  );

  // , valueGetter: ({ data }) =>{

  //   return `$ ${((Number(data.Income).toFixed(2) / income.toFixed(2)) * 100).toFixed(2)}`

  // }
  // useEffect(()=>{
  //  gridRef.current()
  // },[reset])

  useEffect(() => {
    if (column) {
      console.log(columnDefs, "lll");
      const updatedColumnDefs = columnDefs?.map((item, index) => {
        // let updateddata
        if (index == 0) {
          console.log(item, "iii");
          return { ...item, minWidth: 200 };
          // children: [{field: "Customername", minWidth: 200},
          // { field: '% of Column',enableValue: true,
          // suppressMenu: true, minWidth: 200, hide: true }]};
          // columnDefs[index]=updateddata
        } else {
          return {
            ...item,
            children: [
              { field: "", minWidth: 200 },
              {
                field: "% of Column",
                enableValue: true,
                suppressMenu: true,
                minWidth: 200,
              },
            ],
          };
        }
      });
      console.log(updatedColumnDefs, "bbb");
      setColumnDefs(updatedColumnDefs);
    }
  }, [column]);

  console.log(columnDefs.length, "column");

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  // const handleStartDateChange = (momentDate) => {
  //   setStartDate(moment(momentDate).format("YYYY-MM-DD"));
  //   console.log("date",momentDate);
  // };

  // const handleEndDateChange = (momentDate) => {
  //   setEndDate(moment(momentDate).format("YYYY-MM-DD"));
  // };
  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    axios
      .get(
        `${config.reportsBaseUrl}/reports/incomebycustomersummary?startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log("res.data.ResponseData 240", res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const onGridReady = useCallback((params) => {
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/incomebycustomersummary?startdate=${""}&enddate=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log("res.data.ResponseData 270", res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // const autoGroupColumnDef = useMemo(() => {
  //   return {
  //     minWidth: 300,

  //   };
  // }, []);

  useEffect(() => {
    // generateBarcodes();
    // console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Income);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalexpense = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Expense);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalexpense(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalexpense();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel({
      fileName: `Income_Customer_${Moment(currentDate).format("DD-MM-YYYY")}`,
    });
  }, []);

  const totalRow = {
    Customername: "Total",
    Income: responseData.reduce(
      (total, data) => total + Number(data.Income),
      0
    ),
    Expense: responseData.reduce(
      (total, data) => total + Number(data.Expense),
      0
    ),
    "Net Income": responseData.reduce(
      (total, data) => total + Number(data.Income),
      0
    ),
  };

  const rowDataWithTotal = [...responseData, totalRow];

  console.log(
    "rowDataWithTotal 528",
    rowDataWithTotal[rowDataWithTotal.length - 1]
  );

  const handlePrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 23;

    for (var i = 1; i <= Math.ceil(rowDataWithTotal.length / 23); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Company Name</th>' +
        '<th style="padding: 8px;">Income</th>' +
        '<th style="padding: 8px;">Expense</th>' +
        '<th style="padding: 8px;">Net Income</th>';
      content += "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= rowDataWithTotal.length) {
          if (index == rowDataWithTotal.length) {
            content +=
              "<tr>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              rowDataWithTotal[index - 1].Customername +
              "</td>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Expense).toFixed(2) +
              "</td>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>";
          } else {
            content +=
              "<tr>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              rowDataWithTotal[index - 1].Customername +
              "</td>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Expense).toFixed(2) +
              "</td>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>";
          }

          content += "</tr>";
        }

        if (index % 23 == 0) {
          startIndex = startIndex + 23;
          endIndex = endIndex + 23;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  const handleDownlaod = () => {
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 23;

    for (var i = 1; i <= Math.ceil(rowDataWithTotal.length / 23); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Company Name</th>' +
        '<th style="padding: 8px;">Income</th>' +
        '<th style="padding: 8px;">Expense</th>' +
        '<th style="padding: 8px;">Net Income</th>';
      content += "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= rowDataWithTotal.length) {
          if (index == rowDataWithTotal.length) {
            content +=
              "<tr>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              rowDataWithTotal[index - 1].Customername +
              "</td>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Expense).toFixed(2) +
              "</td>" +
              '<td style="font-weight: bold; font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>";
          } else {
            content +=
              "<tr>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              rowDataWithTotal[index - 1].Customername +
              "</td>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Expense).toFixed(2) +
              "</td>" +
              '<td style="font-size: 8px; padding: 8px;">' +
              Number(rowDataWithTotal[index - 1].Income).toFixed(2) +
              "</td>";
          }

          content += "</tr>";
        }

        if (index % 23 == 0) {
          startIndex = startIndex + 23;
          endIndex = endIndex + 23;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Income_Customer_Summary.pdf");
      },
    });
  };

  console.log("rowDataWithTotal 556", rowDataWithTotal);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Income by Customer Summary</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Income by Customer Summary
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3 ">
              <div className="form-group row">
                <label className="col-form-label col-md-5 form-label">
                  Report period
                </label>
                <div className="col-md-7">
                  <Select
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-primary pull-right "
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>

          {/* <div style={{ display: "flex" }}>
            <div className="w-50">
              <label>Compare another period</label>
              <Select
                onChange={(e) => handleChange(e)}
                options={options}
                className="w-50 mt-3"
              />
            </div>
            <div className="w-100">
              <button
                type="submit"
                className="btn btn-primary pull-right mb-3 w-25 mt-0"
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div> */}

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>SonarPos</h2>
                  <p className="fw-bold">Income by Customer Summary</p>
                  <div className="row">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <p>
                      Date: {startdate} - {enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <div className="table mt-3">
                  <div className="button">
                    <button
                      onClick={onBtExport}
                      className="btn btn-sm btn-outline-dark  m-1"
                      // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                    >
                      <i class="fas fa-file-excel "></i>
                      Export to Excel
                    </button>
                    <button
                      onClick={handleDownlaod}
                      className="btn btn-sm btn-outline-dark  m-1"
                      // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                    >
                      <i class="fas fa-file-export "></i>
                      Export to Pdf
                    </button>
                    <button
                      className="btn btn-sm btn-outline-dark  m-1"
                      onClick={handlePrint}
                    >
                      <i class="fas fa-print"></i>
                      Print
                    </button>
                  </div>

                  <div className="grid-wrapper">
                    <div id="myGrid" className="ag-theme-alpine">
                      <AgGridReact
                        ref={gridRef}
                        rowData={rowDataWithTotal}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        onGridReady={onGridReady}
                        // groupIncludeFooter={true}
                        // autoGroupColumnDef={autoGroupColumnDef}
                        groupIncludeTotalFooter={true}
                        rowGroupPanelShow={"always"}
                        // animateRows={true}
                        // onFirstDataRendered={onFirstDataRendered}
                        // pagination={true}
                        // paginationPageSize={1}
                      ></AgGridReact>
                    </div>
                  </div>
                </div>

                {/* <div style={{ textAlign: "right" }} className="mx-5 mt-5">
                  <h6>Total Amount: ${Number(totalSum).toFixed(2)}</h6>
                  <hr
                    style={{
                      display: "inline-block",
                      borderBottom: "3px solid black",
                      width: "30%",
                    }}
                  />
                </div>
                <hr /> */}
              </div>

              <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.map((item) => (
          <>
            {/* <button onClick={console.log("item", item)}>click me</button> */}
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default IncomebyCustomerSummary;
